export default __webpack_public_path__ + "static/media/ISEO CLASS 2 SYLLABUS.6da84870.pdf";